module.exports = __webpack_public_path__ + "img/scaredweb.91576d23.webp";